import { GetProductsResponseItem, ProductServiceTypeEnum } from '../../api/authApi/authApi.types';

export const isPayPerView = (product: GetProductsResponseItem) =>
  product.serviceType !== ProductServiceTypeEnum.SVOD;
